import _ from 'lodash';
import worldMap from '../core/map';
import halo from '../core/map/halo';
import environment from '../environment';
import { DefaultType } from './DefaultType';
import { hidePanelSelectionAlert } from '../../utils';
import { isShallow } from 'vue';
// import 'mapbox.js';

export class VectorType extends DefaultType {
    constructor (options) {
        super(options);

        this._onMapClick = this._onMapClick.bind(this);

        this._markers = [];
    }

    _onMapClick (marker) {
        hidePanelSelectionAlert();
        this.restore(marker);
    }

    unselect (marker, type) {
        type = type || 'select';

        if (!marker) {
          this._markers.forEach(m => {
            if (m.options.iconOriginal.length) {
              m.setIcon(m.options.iconOriginal[0]);
              m.setZIndexOffset(m.options.zIndexOriginal[0]);

              m.options.iconOriginal = [];
              m.options.zIndexOriginal = [];
            }
          });

          this._markers = [];
          return;
        }

        if (type === 'hover' && marker && marker.options.icon && String(marker.options.icon.options.iconUrl).indexOf('pin_highlight') > -1) {
          return marker.options.icon;
        }

        try {
            if (marker && marker.options.iconOriginal && marker.options.iconOriginal.length) {
                marker.setIcon(marker.options.iconOriginal[0]);
                marker.setZIndexOffset(marker.options.zIndexOriginal[0]);

                marker.options.iconOriginal = [];
                marker.options.zIndexOriginal = [];
            }
        } catch (error) {
            console.log('WARNING: marker not defined');
        }

        this._markers = [];
    }

    select (marker, type) {
        type = type || 'select';

        if (worldMap.hasLayer(marker)) {
            marker.options.iconOriginal = [...marker.options.iconOriginal || [], marker.options.icon];
            marker.options.zIndexOriginal = [...marker.options.zIndexOriginal || [], marker.options.zIndexOffset];

            const highlightIcon = (typeAction, size) => {
                if (typeAction === 'hover' && marker._childCount && marker._childCount >= 1 && marker.options.icon) {
                  return marker.options.icon;
                }

                if (typeAction === 'hover' && marker.options.icon.options.iconUrl && marker.options.icon.options.iconUrl.indexOf('pin_highlight') > -1) {
                  return marker.options.icon;
                }

                const iconSize = marker.options.iconOriginal[0].options.iconUrl && marker.options.iconOriginal[0].options.iconUrl.indexOf('circle') > -1
                  ? [40, 40]
                  : [];

                return ({
                    'select': {
                        'sm': L.icon({
                            iconUrl: `${environment.get('IMAGES_HOST')}/pin_highlight_sm.png`,
                            iconSize: [38, 48],
                            iconAnchor: [19, 48],
                            labelAnchor: [19, -24]
                        }),
                        'xs': L.icon({
                            iconUrl: `${environment.get('IMAGES_HOST')}/pin_highlight_sm.png`,
                            iconSize: [38, 48],
                            iconAnchor: [19, 48],
                            labelAnchor: [19, -24]
                        }),
                        'lg': L.icon({
                            iconUrl: `${environment.get('IMAGES_HOST')}/pin_highlight.png`,
                            iconSize: [50, 64],
                            iconAnchor: [25, 60],
                            labelAnchor: [25, -32]
                        }),
                    },
                    'hover': {
                        'sm': L.icon({
                            iconUrl: marker.options.iconOriginal[0].options.iconUrl,
                            iconSize: iconSize.length ? iconSize : [48, 58],
                            iconAnchor: iconSize.length ? undefined : [24, 58],
                            labelAnchor: iconSize.length ? undefined : [24, -34]
                        }),
                        'xs': L.icon({
                            iconUrl: marker.options.iconOriginal[0].options.iconUrl,
                            iconSize: iconSize.length ? iconSize : [48, 58],
                            iconAnchor: iconSize.length ? undefined : [24, 58],
                            labelAnchor: iconSize.length ? undefined : [24, -34]
                        }),
                        'lg': L.icon({
                            iconUrl: marker.options.iconOriginal[0].options.iconUrl
                              ? marker.options.iconOriginal[0].options.iconUrl
                              : marker._icon.src,
                            iconSize: iconSize.length ? iconSize : [60, 74],
                            iconAnchor: iconSize.length ? undefined :[30, 70],
                            labelAnchor: iconSize.length ? undefined : [30, -42]
                        }),
                    },
                }[typeAction][size]);
            };

            const size = marker.options.iconOriginal[0].options.iconUrl && marker.options.iconOriginal[0].options.iconUrl.indexOf('_xs') > -1
              ? 'xs'
              : marker.options.iconOriginal[0].options.iconUrl && marker.options.iconOriginal[0].options.iconUrl.indexOf('_sm') > -1
                ? 'sm'
                : 'lg';

            const icon = highlightIcon(type, size);

            marker.setIcon(icon);
            marker.options.riseOnHover = true;
            marker.setZIndexOffset(999999);

            this._markers.push(marker);
        }
    }

    restore (marker) {
        this.unselect(marker);
        return halo.remove(500);
    }

    highlight (marker, type) {
        const isHighlightOriginal = marker.options.icon.options.iconUrl.indexOf('pin_highlight') > -1;

        if (type === 'click' && isHighlightOriginal) {
          return;
        }

        this.restore();

        if (!isHighlightOriginal) {
          this.select(marker);
          return worldMap.once('click', () => this._onMapClick(marker));
        }

        if (isHighlightOriginal) {
          setTimeout(() => hidePanelSelectionAlert(), 500);
        }
    }

    toggleVisibility (id, layer) {
        const vector = _.isFunction(this.options.layer) ? this.options.layer() : this.options.layer;
        if (vector.layer.hasLayer(layer)) {
            this.restore();
            return vector.hide(id);
        } else {
            return vector.show(id);
        }
    }
}

export default VectorType;



// WEBPACK FOOTER //
// ./src/scripts/controls/VectorType.js